<script lang="ts" setup>
import { DetailComp } from '@/components';
import { RaceContestantDetails } from '@/objects/generated';
import { computed, ref } from 'vue';
import type { FieldAlertMessage } from '@/objects';
import type DetailViewExpose from '@/objects/DetailViewExpose';
import { RaceContestantDetailsGuiDef } from '@/objects/generated/gui';

// We need to keep track of the content element so we can access some of the children
const content = ref<HTMLElement | null>(null);

const contestant = defineModel<RaceContestantDetails>({ required: true });

const detailComp = ref<{ messages: FieldAlertMessage[] } | null>(null);

const changed = ref<boolean>(false);

/**
 * Handle the model value changed event on the DetailComp
 * TODO: We are missing history handling of the CategoryGroup tab.
 * @param value
 * @param originalValue
 */
const handleModelvalueChanged = (value: RaceContestantDetails, originalValue: RaceContestantDetails) => {
    changed.value = JSON.stringify(value) != JSON.stringify(originalValue);
};

/**
 * Callback for providing the GuiDef with the correct fields for the DetailComp
 * Here we can manipulate the ones we need to change
 */
const getRaceContestantGuiDef = () => {
    // We need to handle the CategoryID field
    let guidef = new RaceContestantDetailsGuiDef();

    // We only show the fields in the group 'contestantaddress'
    guidef.Fields = guidef.Fields?.filter((x) => x.Collapsable !== null && x.Collapsable.Collapsable == 'contestantaddress');

    // Reset the Collapsable so it is not collapsable
    guidef.Fields.forEach((x) => (x.Collapsable = null));

    return guidef;
};

defineExpose<DetailViewExpose<RaceContestantDetails>>({
    val: computed(() => contestant.value),
    title: computed(() => ''),
    changed: computed(() => changed.value),
    messages: computed(() => {
        const messages: FieldAlertMessage[] = [];

        if (detailComp.value?.messages && detailComp.value?.messages.length > 0) {
            detailComp.value?.messages.forEach((element) => {
                // This is a bit hacky because the type dissapears somewhere
                messages.push((element as any).message);
            });
        }

        return messages;
    }),
});
</script>
<template>
    <div
        class="d-flex flex-column flex-fill gap-2"
        ref="content"
    >
        <DetailComp
            :gui="getRaceContestantGuiDef()"
            v-model="contestant"
            @update:model-value="handleModelvalueChanged"
            ref="detailComp"
        />
    </div>
</template>
